(($) => {
  Drupal.behaviors.paragraphcarousel = {

    attach: function(context, settings) {
      if (context !== document) {
        return;
      }

      this.init(context, settings);
    },

    init: function(context, settings) {

      // setup sliders:
      this.setupSliders(context);

      // check smoothscroll support:
      const supportsSmoothScroll = duo.Utils.supportsSmoothScroll();

      // navigation event handler:
      $(document).on('click', '.js-paragraph-carousel-navbutton', function(e) {
        const $navButton = $(this);

        // get the parent slider block:
        const $sliderHolder = $navButton.parents('.js-paragraph-carousel');

        // get the scroll-overflow block:
        const $scrollOverflowBlock = $sliderHolder.find('.js-paragraph-carousel-scroller');

        // determine the scroll amount by measuring a list-item:
        const $listItem = $sliderHolder.find('.js-paragraph-carousel-item').first();
        const listItemWidth = $listItem.outerWidth(true);

        // get the scroll direction:
        const direction = $navButton.attr('data-direction');

        // set the new scroll amount:
        const currentScroll = $scrollOverflowBlock.scrollLeft();
        let newScroll = currentScroll + listItemWidth;
        if(direction === 'previous') {
          newScroll = currentScroll - listItemWidth;
        }

        // do the scroll:
        // -> alternative: duo.Utils.smoothScroll($scrollOverflowBlock[0], newScroll, true, supportsSmoothScroll);
        if(supportsSmoothScroll) {
          $scrollOverflowBlock.scrollLeft(newScroll);
        } else {
          $scrollOverflowBlock.animate({
            scrollLeft: newScroll
          }, 200);
        }
      });
    },

    setupSliders: function(context) {
      const self = this;

      // persona slider:
      $(context).find('.persona-slider-block').each(function(index, element) {
        const $sliderBlock = $(element);
        self.setupSlider($sliderBlock, '.persona-slider-list', '.persona-slider-list__item');
      });

      // news slider:
      $(context).find('.news-slider-block').each(function(index, element) {
        const $sliderBlock = $(element);
        self.setupSlider($sliderBlock, '.news-slider-list', '.news-slider-list__item');
      });

      // other coaches slider:
      $(context).find('.othercoach-slider-block').each(function(index, element) {
        const $sliderBlock = $(element);
        self.setupSlider($sliderBlock, '.othercoach-slider-list', '.othercoach-slider-list__item');
      });

      // innovations slider:
      $(context).find('.innovations-slider-block').each(function(index, element) {
        const $sliderBlock = $(element);
        self.setupSlider($sliderBlock, '.innovations-slider-list', '.innovations-slider-list__item');
      });

      // "small links block" slider:
      $(context).find('.p-linksblock-slider-block').each(function(index, element) {
        const $sliderBlock = $(element);
        self.setupSlider($sliderBlock, '.p-linksblock-slider-list', '.p-linksblock-slider-list__item');
      });
    },

    setupSlider: function($sliderBlock, scrollContentSelector, scrollItemSelector) {
      const self = this;

      // add an extra class to the overflow scroll container:
      const $scrollContainer = $(scrollContentSelector);
      $scrollContainer.addClass('js-paragraph-carousel-scroller');

      // add a wrapper around the slider block:
      $sliderBlock.wrap('<div class="js-paragraph-carousel paragraph-carousel"></div>');

      // create navigation buttons:
      const $carouselPrevButton = $(`<button type="button" class="js-paragraph-carousel-navbutton paragraph-carousel__navbutton" data-direction="previous">
        <span class="visually-hidden">${ Drupal.t('Previous') }</span>
          <svg width="22" height="14" viewBox="0 0 22 14" aria-hidden="true" focusable="false">
            <path d="M7 13L1 7l6-6 1.3 1.3L4.5 6H21v2H4.5l3.7 3.7L7 13z" />
          </svg>
        </button>`);
      const $carouselNextButton = $(`<button type="button" class="js-paragraph-carousel-navbutton paragraph-carousel__navbutton" data-direction="next">
        <span class="visually-hidden">${ Drupal.t('Next') }</span>
          <svg width="22" height="14" viewBox="0 0 22 14" aria-hidden="true" focusable="false">
            <path d="M13.8 11.7L17.5 8H1V6h16.5l-3.7-3.7L15 1l6 6-6 6-1.2-1.3z" />
          </svg>
        </button>`);
      // -> add the buttons to the page:
      const $carouselControls = $('<div class="js-paragraph-carousel-navigation paragraph-carousel__navigation"></div>');
      $carouselControls.append($carouselPrevButton);
      $carouselControls.append($carouselNextButton);
      $carouselControls.insertAfter($sliderBlock);

      // add an extra class to every carousel item:
      const $carouselItems = $sliderBlock.find(scrollItemSelector);
      $carouselItems.each(function(index, element) {
        $(element).addClass('js-paragraph-carousel-item');
      });

      // detect if scrollbars are used:
      self._processCarouselNavigation($sliderBlock, scrollContentSelector, scrollItemSelector);
      // -> recalculate on resize (with debouncing):
      const timeoutId = 'carousel' + duo.Utils.uniqueId;
      let timeout = false;
      $(window).once(`paragraphcarousel-${timeoutId}`).on(`resize.carousel-${timeoutId}`, function() {
        clearTimeout(timeout);
        timeout = setTimeout(self._processCarouselNavigation($sliderBlock, scrollContentSelector, scrollItemSelector), 250);
      });

      // add "js-processed" class to the scroll container:
      $sliderBlock.addClass('js-processed');
    },

    _processCarouselNavigation: function($sliderBlock, scrollContentSelector, scrollItemSelector) {

      // check if there's a scrollbar, by measuring the container
      // and the content; if there's no scrollbar, we don't need the navigation

      // get wrapper-width and content-width:
      const $wrapper = $sliderBlock;
      const $content = $wrapper.find(scrollContentSelector);
      const wrapperWidth = $wrapper.width();
      let contentWidth = 0;
      $content.find(`> ${ scrollItemSelector }`).each(function(index, element) {
        const $element = $(element);
        const elementWidth = $element.outerWidth();
        contentWidth += elementWidth;
      });

      // get the parent block:
      const $sliderHolder = $wrapper.parents('.js-paragraph-carousel');

      // get the navigation block:
      const $navigationBlock = $sliderHolder.find('.js-paragraph-carousel-navigation');

      // configure for scroll/no-scroll:
      if(contentWidth > wrapperWidth) {
        // -> content is wider than the wrapper, there's a scroll:
        $wrapper.attr('tabindex', '0');
        $navigationBlock.removeClass('js-inactive');
      } else {
        $wrapper.removeAttr('tabindex', '');
        $navigationBlock.addClass('js-inactive');
      }
    }

  };
})(jQuery);
